// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__OGrAL","ContactInfo":"Footer_ContactInfo__0d0ri","Goal":"Footer_Goal__np8up"};